module.exports = __webpack_public_path__ + "static/media/panco_05.8dd01891.jpg";